import * as React from "react";
import { connect } from "react-redux";
import { Prompt } from "react-router-dom";
import { Modal, ModalBody } from 'reactstrap';
import * as queryString from 'query-string';
import * as types from "../../constants/actionTypes";
import { getFirstName } from "../../helpers/formatting";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import { Redirect } from 'react-router';

class ConfirmationModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = { modalVisible: false, lastLocation: null, confirmedNavigation: false, redirectOnly: false, currentStep: 0, isBack: false, nextStep:0 };
    }

    showModal = (location, isBack = false) => {
        logUI("MBHWeb.UI.ConfirmationModal.Load", new Date(), Tools.getURLPath(), { ...this.props, location });
        this.setState({ modalVisible: true, lastLocation: location, isBack: isBack});
    }

    closeModal = (okToLeave, callback) => {
        let isProxySwitch = typeof window !== 'undefined' && window.userToSwitch ? true : false;
        if (!okToLeave) { // Stay on this page button clicked.       
            logUI(isProxySwitch ? "MBHWeb.UI.ConfirmationModal.ProxySwitch.StayOnPage.Click" : "MBHWeb.UI.ConfirmationModal.StayOnPage.Click", new Date(), Tools.getURLPath());
        }
        else {  //Leave this page button clicked.          
            logUI(isProxySwitch ? "MBHWeb.UI.ConfirmationModal.ProxySwitch.LeaveWithOutSaving.Click" : "MBHWeb.UI.ConfirmationModal.LeaveWithOutSaving.Click", new Date(), Tools.getURLPath());
        }
        this.setState({ modalVisible: false, redirectOnly: false }, callback ? callback : () => window.userToSwitch = null /*this.props.unmarkUserToSwitch()*/);
        this.props.updateMenu(location.pathname);
        this.props.stayOnIncompleteForm(!okToLeave);
        if (okToLeave && this.props.callbackOnLeave) {
            this.props.callbackOnLeave(this.state.lastLocation.pathname);
        }
        if (this.props.onConfirmed) {
            this.props.onConfirmed();
        }
    }

    onConfirmed = (okToLeave) => {
        const { lastLocation, isBack, currentStep, nextStep } = this.state;
        this.closeModal(okToLeave, () => {
            if (lastLocation) {
                this.setState({
                    confirmedNavigation: true
                }, () => {
                        if (this.props.showModelInAllSteps) {
                            if (isBack) {
                                this.setState({ confirmedNavigation: false, redirectOnly: false, currentStep: nextStep, nextStep: 0 });
                                const noofSteps = currentStep - nextStep;
                                this.props.history.go("-" + noofSteps);
                            }
                            else if (this.props.showModelInAllSteps && !isBack) {
                                this.setState({ confirmedNavigation: false, redirectOnly: true, currentStep: nextStep, nextStep: 0 });
                            }
                        }
                        else {
                            this.setState({ confirmedNavigation: true, redirectOnly: true });
                            //this.props.history.push({ pathname: lastLocation.pathname, searchParms: lastLocation.search, searchParams: lastLocation.searchParams ? lastLocation.searchParams : "" });
                        }
                });
            }
        });
    }

    handleBlockedNavigation(nextLocation) {
        const { isSyncUserSwitch, userIsSwitching } = this.props;
        //if syncuserswitch is true then we need to return to show modal when user switches(isSyncUserSwitch).
        if (!this.props.showModelInAllSteps && (!this.state.confirmedNavigation || (typeof isSyncUserSwitch !== 'undefined' && isSyncUserSwitch && window.userToSwitch && !userIsSwitching))) {
            // if (!this.props.userToSwitch) {
            if (!window.userToSwitch) {
                //blocking the navigation use case for proxy - We need modal for menus and not required for back/next
                if (this.props.blockNavigation) {
                    const shouldBlock = this.props.blockNavigation(nextLocation);
                    if (shouldBlock)
                        return true;
                }
                const searchParams = nextLocation.search ? queryString.parse(nextLocation.search) : nextLocation.pathname;
                if (searchParams && searchParams.s) // if the new location is pushed from OurStepManager, no need to show Modal
                    return true;
            }
            if (nextLocation)
                this.showModal(nextLocation, false);
            return false;
        }

        //Added below code to show ConfirmationModal in All Steps of GrantAccessProxyRequest.js
        if (this.props.showModelInAllSteps && !this.state.confirmedNavigation) {
            let showModal = false;
            let isBack = false;
            const { currentStep } = this.state;
            if (!window.userToSwitch) {
                const searchParams = nextLocation.search ? queryString.parse(nextLocation.search) : nextLocation.pathname;
                const nextStep = searchParams && searchParams.s && (typeof searchParams.s !== "undefined") ? searchParams.s : 0;

                //Check if clicked outside the stepManager
                if (this.props.blockNavigation) {
                    const isInStepManager = this.props.blockNavigation(nextLocation);
                    showModal = !isInStepManager;
                }

                //Check if clicked inside the stepManager
                if (!showModal  && currentStep > nextStep && nextLocation.search === window.location.search) {
                            showModal = true;
                            isBack = true;
                }

                if (showModal) {
                    this.setState({ currentStep, nextStep });
                    this.showModal(nextLocation, isBack);
                }
                else {
                    this.setState({ currentStep: nextStep, nextStep: 0 });
                }
            }
            else {
                this.showModal(nextLocation, false);
                return false;
            }
            return showModal ? false : true;
        }

        return true;
    }

    render() {
        let { when, message, actionText1, actionText2, noReload, userSwitchMsg, blockUserSwitch, blockUserSwitchMsg } = this.props;
        const { modalVisible, redirectOnly, lastLocation } = this.state;
        const userToSwitchMsg = typeof userSwitchMsg !== 'undefined' && userSwitchMsg ? ` ${userSwitchMsg}` : "";

        if (window.userToSwitch && !blockUserSwitch) {
            const firstName = getFirstName(window.userToSwitch.displayName);
            message = "Are you sure you want to switch to " +
                (window.userToSwitch.isPrimary ? "your own" : firstName + "'s") +
                " account" + (noReload ? "" : userToSwitchMsg ? userToSwitchMsg : " and lose your changes") + "?";
            actionText1 = "YES";
            actionText2 = "NO";
        }

        if (window.userToSwitch && blockUserSwitch) {
            message = blockUserSwitchMsg ? blockUserSwitchMsg : "The account cannot be switched on this page.";
        }

        return (redirectOnly ? <Redirect to={{ pathname: lastLocation.pathname, search: lastLocation.search }} />
            :
            <div>
                <Modal className="verify-modal" isOpen={modalVisible} toggle={() => this.closeModal()} centered>
                    <ModalBody>
                        <div className="row">
                            <div className="col-12">
                                <p>{message ? message : 'Would you like to continue without saving?'}</p>
                                {window.userToSwitch && blockUserSwitch
                                    ? <button type="button" className="btn text-btn" onClick={() => this.closeModal(false)}>
                                        {actionText1 ? actionText1 : 'OKAY'}
                                        </button>
                                    : <div className="row link-container">
                                        <div className="col-6 link-right" onClick={() => window.userToSwitch ? this.onConfirmed(true) : this.closeModal()}>
                                            {actionText1 ? actionText1 : 'STAY ON THIS PAGE'}
                                        </div>
                                        <div className="col-6 link-left" onClick={() => window.userToSwitch ? this.closeModal() : this.onConfirmed(true)}>
                                            {actionText2 ? actionText2 : 'CONTINUE WITHOUT SAVING'}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                <Prompt when={when} message={(nextLocation) => this.handleBlockedNavigation(nextLocation)} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        history: state.session.history,
        userIsSwitching: state.memberships.switchingProxyUser
        //userToSwitch: state.common.userToSwitch
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        stayOnIncompleteForm: (stay) => dispatch({ type: types.STAY_ON_INCOMPLETE_FORM, stay }),
        //unmarkUserToSwitch: () => dispatch({ type: types.USER_TO_SWITCH, user: null }),
        updateMenu: (currentLocation) => dispatch({ type: types.UPDATE_MENU, currentLocation })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationModal);